<template>
  <div class="payment-channel-picker">
    <div v-if="loading" class="text-center p-3">
      <div class="spinner-border spinner-border-sm text-primary"></div>
      <p class="text-muted small mt-2 mb-0">Memuat metode pembayaran...</p>
    </div>
    <div v-else>
      <div
        v-for="ch in grouped.manual"
        :key="ch.code"
        class="channel-card"
        :class="{ active: value === ch.code }"
        @click="select(ch)"
      >
        <input type="radio" :value="ch.code" :checked="value === ch.code" @change="select(ch)">
        <div class="channel-body">
          <b>{{ ch.name }}</b>
          <small v-if="ch.code === 'transfer_manual'" class="text-muted d-block">Transfer ke rekening, kirim bukti</small>
          <small v-else-if="ch.code === 'cod'" class="text-muted d-block">Bayar saat barang sampai</small>
        </div>
      </div>

      <div v-for="section in channelSections" :key="section.key" class="mt-3">
        <h6 class="text-muted section-label">{{ section.label }}</h6>
        <div class="row">
          <div
            v-for="ch in grouped[section.key]"
            :key="ch.code"
            class="col-md-6 mb-2"
          >
            <div
              class="channel-card h-100"
              :class="{ active: value === ch.code }"
              @click="select(ch)"
            >
              <input type="radio" :value="ch.code" :checked="value === ch.code" @change="select(ch)">
              <div class="channel-body">
                <img v-if="ch.icon_url" :src="ch.icon_url" class="channel-icon" alt="">
                <span>{{ ch.name }}</span>
                <small v-if="ch.fee_flat || ch.fee_percent" class="text-muted d-block mt-1">
                  Fee: {{ formatFee(ch) }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!channels.length" class="empty-channels text-center p-4">
        <i class="fas fa-credit-card text-muted mb-2" style="font-size:28px;"></i>
        <p class="text-muted mb-0">{{ emptyMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { groupPaymentChannels, formatPaymentFee } from './shop_public_utils';

export default {
  name: 'PaymentChannelPicker',
  props: {
    channels: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    value: { type: String, default: '' },
    emptyMessage: {
      type: String,
      default: 'Toko ini belum mengaktifkan metode pembayaran. Hubungi penjual.',
    },
  },
  computed: {
    grouped() {
      return groupPaymentChannels(this.channels);
    },
    channelSections() {
      return [
        { key: 'qris', label: 'QRIS' },
        { key: 'va', label: 'Virtual Account' },
        { key: 'ewallet', label: 'E-Wallet' },
        { key: 'convenience', label: 'Minimarket' },
      ].filter(s => this.grouped[s.key].length > 0);
    },
  },
  methods: {
    select(ch) {
      this.$emit('input', ch.code);
    },
    formatFee: formatPaymentFee,
  },
};
</script>

<style scoped>
.channel-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  background: #fff;
}
.channel-card:hover {
  border-color: #90caf9;
}
.channel-card.active {
  border-color: var(--theme-color, #1976d2);
  background: #f0f7ff;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}
.channel-body {
  flex: 1;
  min-width: 0;
}
.channel-icon {
  height: 22px;
  vertical-align: middle;
  margin-right: 8px;
}
.section-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}
.empty-channels {
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px dashed #dee2e6;
}
</style>
